import React from 'react'

import { arrayOf, func, shape, string } from 'prop-types'

import { NOOP } from 'Utils/stableDefaults'

function CollectionGallery({ images, href = null, collectionTitle = '', onItemClick = NOOP }) {
  if (!images?.length) {
    return null
  }

  const ItemWrapper = href ? 'a' : 'div'
  const linkProps = href
    ? { href, 'aria-label': `View ${collectionTitle || 'collection'}`, onClick: onItemClick }
    : {}

  return (
    <div className="collection-gallery">
      {images.map((image) => (
        <ItemWrapper key={image.id} {...linkProps} className="collection-gallery__item">
          <img
            src={image.url}
            alt={image.alt}
            className="collection-gallery__image"
            loading="lazy"
            width={246}
            height={192}
          />
        </ItemWrapper>
      ))}
    </div>
  )
}

CollectionGallery.propTypes = {
  images: arrayOf(
    shape({
      id: string.isRequired,
      url: string.isRequired,
      alt: string.isRequired,
    })
  ).isRequired,
  href: string,
  collectionTitle: string,
  onItemClick: func,
}

export default CollectionGallery
